import axios from "axios";
import swal from "sweetalert";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import jwtEncode from "jwt-encode";


export const SERVER_IP = "https://api.assist.simulanis.io:3005";
export const UNO_URL = 'https://api.simulanis.io';
export const CDN_URL = 'https://cdn.simulanis.io';
export const redirectUrl = "https://apps2.simulanis.io";

// export const SERVER_IP = 'https://nodecontainer-dze4ewg7bsh3esbt.centralindia-01.azurewebsites.net';
// export const UNO_URL = 'https://nodecontainer2-bze9eeftc4ajh7gh.centralindia-01.azurewebsites.net';
// export const CDN_URL = 'https://nodecontainer2-bze9eeftc4ajh7gh.centralindia-01.azurewebsites.net';
// export const redirectUrl = "https://nodecontainer3-cpbvgbdkgzffa3be.centralindia-01.azurewebsites.net";

// export const SERVER_IP = 'https://dgdiwabackenduat.adnoc.ae';     // ADNOC UAT
// export const UNO_URL = 'https://dgdiwaunobackenduat.adnoc.ae';
// export const CDN_URL = 'https://dgdiwaunobackenduat.adnoc.ae';
// export const redirectUrl = "https://dgdiwaunouat.adnoc.ae";

// export const SERVER_IP = 'https://ddiwasvr.dalmadc.local:3005';     // honeywell
// export const UNO_URL = "https://ddiwasvr.dalmadc.local:3003"; 
// export const CDN_URL = "https://ddiwasvr.dalmadc.local:3003"; 
// export const redirectUrl = "https://ddiwasvr.dalmadc.local:3065";   

export const applicationId = "fed6f7e9-d8bf-457e-97e2-501234d65202";

export const PORT = "3005";
export const PORT_webRTC = "49445";

export const Communication_obj = true;
export const Security = false;

export var LICENSE = {};

export var jwt = sessionStorage.getItem("jwt");
export var ud = JSON.parse(sessionStorage.getItem("ud"));

export const changeUserInfo = (jwt_info, ud_info) => {
  ud = ud_info;
  jwt = jwt_info;
  sessionStorage.setItem("jwt", `${jwt_info}`);
  sessionStorage.setItem("ud", `${JSON.stringify(ud_info)}`);
  return;
};

const mapStateToProps = (state) => ({
  user: state.userData,
  userDetails: state.userData.userDetails,
});

const logoutAndRedirect = async () => {
  let UnoToken = localStorage.getItem("unoToken");
  try {
    await axios.post(`${UNO_URL}/api/auth/logout`, {}, {
      headers: {
        Authorization: `Bearer ${UnoToken}`,
      },
    }
    );
  } catch (error) {
    console.log(error);
  } finally {
    const storageConfig = localStorage.getItem("configuration");
    const configData = JSON.parse(storageConfig);
    let _redirectTo = configData?.redirectUrl || redirectUrl;
    const payload = {
      logout: true,
    };
    const token = jwtEncode(payload, "");
    localStorage.clear();
    sessionStorage.clear();
    
    window.location.href = `${_redirectTo}?referrer=${token}`;
  }
};

export default withRouter(connect(mapStateToProps)(logoutAndRedirect));



export const logout = {
  async logout() {
    // if (ud.usertype == 0) {
    //     sessionStorage.clear();
    //     localStorage.clear();
    //     window.location.href = '/login'
    //     return
    // }
    // else {
    let UnoToken = localStorage.getItem("unoToken");
    var req_data = {
      session_id: ud.session_id,
      user_id: ud.id,
      unoToken: UnoToken
    };
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };

    // logoutAndRedirect();
    axios.post(`${SERVER_IP}/usersLogout`, req_data, { withCredentials: true, headers: headers })

    const storageConfig = localStorage.getItem("configuration");
    const configData = JSON.parse(storageConfig);
    let _redirectTo = configData?.redirectUrl || redirectUrl;

    const payload = {
      logout: true,
    };
    const token = jwtEncode(payload, "");

    let localName = localStorage.getItem("light_DarkMode");
    localStorage.setItem("light_DarkMode", localName);
    sessionStorage.clear();
    localStorage.clear();

    window.location.href = `${_redirectTo}?referrer=${token}`;


  },
  // }
};

export const Workflow_Evidence_Path = "/evidence/";

export const sample_csv = `${SERVER_IP}/icons/SampleCSVRemoteAssist.csv`;

export const auth_response_flow = (response, callback) => {
  if (response.error == true) {
    /*
     * For Middleware Authentication
     */
    if (response.flag_name) {
      if (response.flag_name === "UPDATE") {
        changeUserInfo(response.JWT_token, response.details);
        let obj = {
          error: false,
          retry: true,
        };
        return callback(obj);
      } else if (response.flag_name === "LOGOUT") {
        logout.logout();
        return;
      } else if (response.flag_name === "SOMETHING_WENT_WRONG") {
        logout.logout();
        return;
      }
    } else {
      /*
       * For Other Error Logs
       */
      // if (response.message) {
      //     swal(response.message, "", "warning")
      // } else if (response.status.message) {
      //     swal(response.status.message, "", "warning")
      // }
      let obj = {
        error: false,
        retry: false,
      };
      return callback(obj);
      return;
    }
  }
};

export const UpdateLicense = () => {
  let license_obj_string = sessionStorage.getItem("license");

  if (license_obj_string == "" || license_obj_string == null) {
    getLicenseInfo();
  } else {
    let license_obj = JSON.parse(license_obj_string);
    let minutes = (new Date().getTime() - new Date(license_obj.updated_time).getTime()) / (60 * 1000);

    if (minutes > 1 || minutes < 0) {
      getLicenseInfo();
    } else {
      LICENSE = license_obj;
      setTimeout(() => UpdateLicense(), 60000);
    }
  }
};

export const getLicenseInfo = () => {
  let data = {
    c_id: ud.c_id,
  };
  let headers = {
    user_id: ud.id.toString(),
    session_id: ud.session_id.toString(),
    user_type: ud.usertype.toString(),
    main_id: ud.main_id.toString(),
    jwt_token: jwt,
    c_id: ud.c_id.toString(),
  };
  let _this = this;
  axios
    .post(`${SERVER_IP}/fetchLicenseDetails`, data, { withCredentials: true, headers: headers })
    .then(function (response) {
      if (response.status === 200) {
        if (response.data.error === false) {
          sessionStorage.setItem(
            "license",
            JSON.stringify({ ...response.data.completeLicense, updated_time: new Date() })
          );
          LICENSE = { ...response.data.completeLicense, updated_time: new Date() };
          setTimeout(() => UpdateLicense(), 60000);
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              getLicenseInfo();
            }
          });
        }
      }
    })
    .catch(function (error) { });
};

// API Routes
// export const create_api = ''
